import React, { useState } from "react";

import useSearchAndFilter from "../../../../hooks/useSearchAndFilter";
import { Table } from "../../../../components/shared";
import { Loader } from "../../../../components/loaders/loaders";
import {
    ServiceTypeResponseType,
    OrderStatusTableConfig,
} from "../Services-types";
import { AddIcon, FilterIcon, FilterIconWhite } from "../../../../assets";
import { GET_SERVICES } from "../../../../apis/end-points";
import FilterSideMenu from "../../../../components/shared/FilterSideMenu";
import { Badge } from "@mui/material";
import OmniServiceModal from "../../../../components/modals/systemConfigurationModal/OmniServiceModal";
import { DEFAULT_PAGE_SIZE } from "../../../../utils/constants";


/**
 * Maps order status data from the API response to the format required by the table.
 *
 * @returns {object[]} - Mapped order status data.
 */
const mapOrderStatusData = (data: ServiceTypeResponseType[]): object[] =>
    data.map((item) => ({
        id: item?.id || "",
        count: item?.count || "",
        serviceName: item?.name || "",
        onwardServiceName: item?.onwardServiceName || "--",
        // active: item?.isActive || false,
    }));

const OnwardServiceListing: React.FC = () => {
    const [openAddOrderStatusModal, setOpenAddOrderStatusModal] =
        useState<boolean>(false);
    const [rowData, setRowData] = useState<any>();

    const {
        data,
        loading,
        setLoading,
        fetchFilteredData,
        closeOpenfilterModal,
        isShowFilterModal,
        selectStatus,
        setSelectStatus,
        refreshPage,
        service,
        setService,
        filterApplied,
        setFilterApplied,
        onwardService,
        setOnwardService,
        fetchWithCurrentFilters,
        captureAppliedFilters,
        clearCurrentFilters,
    } = useSearchAndFilter<ServiceTypeResponseType>({
        apiUrl: GET_SERVICES,
        limit: DEFAULT_PAGE_SIZE,
        mapUserData: mapOrderStatusData,
        screenKey: "omniMoveUserService",
    });

    const handleEditModal = (data: any) => {
        setOpenAddOrderStatusModal(true);
        setRowData(data);
    };

    return (
        <>
            <div
                className={`tableWrap ${isShowFilterModal ? "tableWrap--filterOpen" : ""
                    }`}
            >
                <div className="tableWrap__head tableWrap__head--end">
                    <div className="btn__group">
                        {filterApplied ? (
                            <Badge badgeContent=" " color="primary">
                                <button
                                    className={
                                        !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                                    }
                                    onClick={closeOpenfilterModal}
                                >
                                    {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                                    Filter
                                </button>
                            </Badge>
                        ) : (
                            <button
                                className={
                                    !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                                }
                                onClick={closeOpenfilterModal}
                            >
                                {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                                Filter
                            </button>
                        )}
                        <FilterSideMenu
                            isShowFilterModal={isShowFilterModal}
                            closeOpenfilterModal={closeOpenfilterModal}
                            selectStatus={selectStatus}
                            setSelectStatus={setSelectStatus}
                            isStatusHide={true}
                            isRoleHide={true}
                            isOrderStatusHide={true}
                            isOrderTypeHide={true}
                            isAgentTypeHide={true}
                            isHubHide={true}
                            isServiceHide={true}
                            isCustomerTypeHide={false}
                            isAllCustomerTypeHide={true}
                            showService={true}
                            service={service}
                            setService={setService}
                            fetchFilteredData={fetchFilteredData}
                            onFiltersApplied={captureAppliedFilters}
                            filterApplied={filterApplied}
                            setFilterApplied={setFilterApplied}
                            showonwardService={true}
                            onwardService={onwardService}
                            setOnwardService={setOnwardService}
                            table="onwardServiceListing"
                            clearFiltersFromStorage={clearCurrentFilters}
                        />
                        {/* <button
              className="btn btn__white w_fitContent"
              onClick={() => setOpenAddOrderStatusModal(true)}
            >
              <AddIcon />
              Create New
            </button> */}
                    </div>
                </div>

                <Table
                    columns={OrderStatusTableConfig.columns}
                    data={data}
                    setLoading={setLoading}
                    editModalHanlde={handleEditModal}
                    //   onDeleteConfig={OrderStatusTableConfig.delete}
                    //   onActiveConfig={OrderStatusTableConfig.active}
                    getApiData={fetchWithCurrentFilters}
                    //   deleteIcon={true}
                    //   activeIcon={true}
                    editIcon={true}
                />
            </div>

        {openAddOrderStatusModal && (
        <OmniServiceModal
          handleClose={() => {
            setOpenAddOrderStatusModal(false);
            setRowData(null);
          }}
          setLoading={setLoading}
          refreshList={() => refreshPage()}
          data={rowData}
        />
      )}

            {loading && <Loader />}
        </>
    );
};

export default OnwardServiceListing;